// AdminLayout.tsx
import React, {FormEvent, useState} from 'react';
import {AppShell, Burger, Button, Flex, Image, Menu, Title} from '@mantine/core';
import {Routes, Route, Navigate, useNavigate} from 'react-router-dom';
import OrganizationManager from "../../../ui/Organization/admin/OrganizationManager";
import OrganizationDetails from "../../../ui/Organization/admin/OrganizationDetails";
import {Navigation} from "./Navigation";
import {useDisclosure} from "@mantine/hooks";
import {getToken, removeToken} from "../../../auth/service/authService";
import {Colors} from "../../../util/colors";
import {TemplateManager} from "../TemplateManager";
import logo from "../../../util/logo.png";
import {Overview} from "../Overview";
import DatenschutzErklaerung from "../../../ui/information/lawstuff/Datenschutz";
import AGB from "../../../ui/information/lawstuff/AGB";
import Impressum from "../../../ui/information/lawstuff/Impressum";
import {jwtDecode} from "jwt-decode";
import axios from "axios";
import {BackendUrl} from "../../../util/config";
import {IconArrowsLeftRight, IconLock} from "@tabler/icons-react";


export const AdminLayout: React.FC = () => {

    const navigate = useNavigate()

    const token = getToken()

    const [message, setMessage] = useState<String | null>(null);
    const [error, setError] = useState<String | null>(null);


    const [mobileOpened, { toggle: toggleMobile }] = useDisclosure();
    const [desktopOpened, { toggle: toggleDesktop }] =
        useDisclosure(true);

    const handleLogout =() => {
        removeToken();
        navigate("/login");
    }

    const handleResetPassword = async (e: FormEvent) => {
        e.preventDefault();
        if(token){
            const email = jwtDecode(token).sub
            try {
                const response = await axios.post(BackendUrl + '/auth/forgot-password', { email });
                setMessage(response.data.message);
            } catch (err: any) {
                setError(err.response?.data?.error || 'Something went wrong');
            }
        }

    };

    return (
        <AppShell
            navbar={{
                width: 300,
                breakpoint: 'sm',
                collapsed: { mobile: !mobileOpened, desktop: !desktopOpened },
            }}
        >
            {/*
        Nested routing for admin pages
        Since this is rendered inside RoleBasedLayout,
        we can define the admin-specific routes here
      */}

            <AppShell.Header >
                <Flex align={"center"} justify={"space-between"} h={"100%"} p={"sm"}>
                    <Flex align={"center"} gap={"sm"}>
                        <Burger
                            opened={mobileOpened}
                            onClick={toggleMobile}
                            hiddenFrom="sm"
                            size="sm"
                        />
                        <Burger
                            opened={desktopOpened}
                            onClick={toggleDesktop}
                            visibleFrom="sm"
                            size="sm"
                        />
                        <Image
                            h={40}
                            radius="md"
                            src={logo}
                        />
                        <Title c={Colors.Reinrot}>
                            Administrator Sicht
                        </Title>
                    </Flex>
                    <Menu shadow="md" width={200}>
                        <Menu.Target>
                            <Button variant={"light"}>Nutzerkonto</Button>
                        </Menu.Target>

                        <Menu.Dropdown>


                            <Menu.Label>Danger zone</Menu.Label>
                            <Menu.Item
                                leftSection={<IconArrowsLeftRight size={14} />}
                                onClick={handleResetPassword}
                            >
                                Passwort ändern
                            </Menu.Item>
                            <Menu.Item
                                color="red"
                                leftSection={<IconLock size={14} />}
                                onClick={handleLogout}
                            >
                                Abmelden
                            </Menu.Item>
                        </Menu.Dropdown>
                    </Menu>
                </Flex>


            </AppShell.Header>
            <Navigation></Navigation>
            <AppShell.Main>
                <Routes>
                    {/* Admin dashboard or “main” */}

                    {/* Admin org management */}
                    <Route path="/organizations" element={<OrganizationManager />} />
                    <Route path="/organizations/:id" element={<OrganizationDetails />} />

                    {/* Admin document management */}
                    <Route path="/templates" element={<TemplateManager />} />

                    <Route path="/overview" element={<Overview />} />

                    <Route path="/datenschutzerklärung" element={<DatenschutzErklaerung />} />
                    <Route path="/agb" element={<AGB />} />
                    <Route path="/impressum" element={<Impressum />} />

                    {/* Catch-all: if no match, redirect to admin dashboard */}
                    <Route path="*" element={<Navigate to="/overview" />} />
                </Routes>
            </AppShell.Main>

        </AppShell>
    );
};
